import { db } from "@poseidon/firebase/firebase";
import { doc, DocumentReference, DocumentSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useDocument } from "react-firebase-hooks/firestore";
import { actionSchema } from "./actionSchema";

export interface Action {
  actionFor?: DocumentReference | string;
  origin?: string | undefined;
  completedBy?: DocumentReference | string;
  state: string;
  note?: string;
}

export const useAction = ({ entity, entityId, entityKey }: any) => {
  const [action, setAction] = useState<Action>();
  const docRef = doc(db, entity, entityId, "actions", entityKey);
  const [value, loading, error] = useDocument(docRef, {
    snapshotListenOptions: { includeMetadataChanges: true },
  });
  useEffect(() => {
    const run = async () => {
      if (value?.exists()) {
        const action = await mapAction(value);
        setAction(action);
      }
    };

    run();
  }, [value, entity, entityId, entityKey]);

  return { action, loading, error, docRef };
};

const mapAction = async (snap: DocumentSnapshot) => {
  return actionSchema.cast(snap.data());
};
